<div class="main">
  <div class="border"></div>
  <div class="logo-banner">
    <img src="../assets/images/NHFLogo.png" />
  </div>
  <div class="toolbar">
    <!-- <a class="button" mat-button> HOME </a>
    <a class="button" mat-button> ABOUT </a>
    <a class="button" mat-button> INITIATIVES </a>
    <a class="button" mat-button> GET INVOLVED </a>
    <a class="button" mat-button> EVENTS </a>
    <a class="button" mat-button> GALLERY </a>
    <a class="button" mat-button> NEWS </a>
    <a class="button" mat-button> CONTACT </a>
    <a class="button-white" href="/teatime" mat-button> TEA TIME </a>
    <a class="button-white" mat-button> DONATE NOW </a> -->
    <a class="button-white" [routerLink]="'scholarship'" mat-button>
      SCHOLARSHIP
    </a>
    <a
      class="button-white"
      [routerLink]="'admin'"
      mat-button
      *ngIf="adminLoggedIn"
    >
      ADMIN DASHBOARD
    </a>
    <a class="button-white" mat-button *ngIf="adminLoggedIn" (click)="logout()">
      LOGOUT
    </a>
    <a class="button-white" mat-button (click)="login()" *ngIf="!adminLoggedIn">
      ADMIN LOGIN
    </a>
  </div>
  <router-outlet></router-outlet>
  <div class="partners">
    <div class="header">OUR PARTNERS</div>
    <div class="underline"></div>
    <div class="blurb">
      These companies and organizations play a vital role in our mission
      fulfillment.
    </div>
    <div class="logos">
      <div class="logo">
        <img class="logo-image" src="../assets/images/UA.png" />
      </div>
      <div class="logo">
        <img class="logo-image" src="../assets/images/USATF.jpg" />
      </div>
      <div class="logo">
        <img class="logo-image" src="../assets/images/YTG.jpeg" />
      </div>
      <div class="logo">
        <img class="logo-image" src="../assets/images/TG.png" />
      </div>
      <div class="logo-plain">
        <img class="logo-image" src="../assets/images/Curls.png" />
      </div>
      <div class="logo-plain">
        <img class="logo-image" src="../assets/images/PP.jpeg" />
      </div>
      <div class="logo">
        <img class="logo-image" src="../assets/images/MB.png" />
      </div>
    </div>
  </div>
  <div class="footer">
    <img src="../assets/images/InvertedLogo.png" />
    <!-- <div class="socials">
      <i class="fab fa-facebook-f"></i>
      <i class="fab fa-instagram"></i>
      <i class="fab fa-twitter"></i>
      <i class="fab fa-vimeo-v"></i>
    </div> -->
    <div class="address">
      <div class="line1">The Natasha Hastings Foundation</div>
      <div>P.O. Box 424</div>
      <div>Cedar Park, TX 78630</div>
    </div>
    <!-- <div class="policies">
      <a href="http://www.google.com" target="_blank"> PRIVACY POLICY </a>
      <i class="fas fa-circle"></i>
      <a href="http://www.google.com" target="_blank"> WEBSITE USE </a>
      <i class="fas fa-circle"></i>
      <a href="http://www.google.com" target="_blank"> DONOR POLICY </a>
    </div> -->
    <div class="line">
      THE NATASHA HASTINGS FOUNDATION IS A 501(c)(3) ORGANIZATION
    </div>
    <div class="footnote">
      <div>© 2019 The Natasha Hastings Foundation. All rights reserved.</div>
      <i class="fas fa-circle"></i>
      <div>Website Powered by Hastings Web Design</div>
    </div>
  </div>
  <div class="border"></div>
</div>
